import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { faqArticle } from '@/mocks/articleData';

export default function FaqArticle() {
  return (
    <>
      <Navbar />
      <ArticleTemplate article={faqArticle} />
      <Footer />
    </>
  );
}